module.exports = __webpack_public_path__ + "img/delivery.fb0040b1.png";